module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch4_20210921063834_T.9f294a6e.jpg";